var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form",
    { staticClass: "company-modal__form" },
    [
      _c("div", { staticClass: "row gutter-lg items-start" }, [
        _c("div", { staticClass: "col-sm-auto col-12 gt-xs" }, [
          _c(
            "div",
            {
              staticClass: "bg-grey-1 circle text-center q-mr-lg",
              staticStyle: {
                height: "125px",
                width: "125px",
                "line-height": "125px"
              }
            },
            [
              _c("q-icon", {
                staticClass: "bg-grey-1 circle",
                attrs: { name: "business", color: "grey-3", size: "100px" }
              })
            ],
            1
          )
        ]),
        _c(
          "div",
          { staticClass: "col-sm col-12" },
          [
            _c(
              "div",
              { staticClass: "row" },
              [
                _c(
                  "q-field",
                  {
                    staticClass: "col-12",
                    attrs: {
                      error: _vm.errors.has("companyName"),
                      "error-label": _vm.errors.first("companyName")
                    }
                  },
                  [
                    _c("q-input", {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate.disable",
                          value: "required|min:1|max:255",
                          expression: "'required|min:1|max:255'",
                          modifiers: { disable: true }
                        }
                      ],
                      ref: "companyName",
                      attrs: {
                        name: "companyName",
                        placeholder: _vm.$t("company_name"),
                        required: ""
                      },
                      model: {
                        value: _vm.formData.name,
                        callback: function($$v) {
                          _vm.$set(_vm.formData, "name", $$v)
                        },
                        expression: "formData.name"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            ),
            !_vm.restrictToBusinessPartnerType
              ? _c(
                  "div",
                  { staticClass: "row" },
                  [
                    _c(
                      "q-field",
                      {
                        staticClass: "col-12",
                        attrs: {
                          error: _vm.errors.has("businessPartnerType"),
                          "error-label": _vm.errors.first("businessPartnerType")
                        }
                      },
                      [
                        _c("q-select", {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate.disable",
                              value: "required",
                              expression: "'required'",
                              modifiers: { disable: true }
                            }
                          ],
                          attrs: {
                            options: _vm.businessPartnerTypeOptions,
                            placeholder: _vm.$t("business_partner_type"),
                            name: "businessPartnerType",
                            required: ""
                          },
                          model: {
                            value: _vm.formData.businessPartnerType,
                            callback: function($$v) {
                              _vm.$set(_vm.formData, "businessPartnerType", $$v)
                            },
                            expression: "formData.businessPartnerType"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              : _vm._e(),
            _vm.showAllFields
              ? [
                  _c(
                    "div",
                    { staticClass: "row gutter-x-sm" },
                    [
                      _c(
                        "q-field",
                        {
                          staticClass: "col-12 col-md-6",
                          attrs: {
                            icon: "account_balance",
                            error: _vm.errors.has("vat_number"),
                            "error-label": _vm.errors.first("vat_number")
                          }
                        },
                        [
                          _c("q-input", {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate.disable",
                                value: "min:3|max:255",
                                expression: "'min:3|max:255'",
                                modifiers: { disable: true }
                              }
                            ],
                            attrs: {
                              name: "vatNumber",
                              placeholder: _vm.$t("vat_number")
                            },
                            model: {
                              value: _vm.formData.vatNumber,
                              callback: function($$v) {
                                _vm.$set(_vm.formData, "vatNumber", $$v)
                              },
                              expression: "formData.vatNumber"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "q-field",
                        {
                          staticClass: "col-12 col-md-6",
                          attrs: {
                            error: _vm.errors.has("tax_number"),
                            "error-label": _vm.errors.first("tax_number")
                          }
                        },
                        [
                          _c("q-input", {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate.disable",
                                value: "min:3|max:255",
                                expression: "'min:3|max:255'",
                                modifiers: { disable: true }
                              }
                            ],
                            attrs: {
                              name: "vatNumber",
                              placeholder: _vm.$t("tax_number")
                            },
                            model: {
                              value: _vm.formData.taxNumber,
                              callback: function($$v) {
                                _vm.$set(_vm.formData, "taxNumber", $$v)
                              },
                              expression: "formData.taxNumber"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]
              : _vm._e(),
            _vm.showAllFields
              ? _c(
                  "div",
                  { staticClass: "row" },
                  [
                    _c(
                      "q-field",
                      {
                        staticClass: "col-12",
                        attrs: {
                          icon: "calendar_today",
                          error: _vm.errors.has("defaultPaymentDeadline"),
                          "error-label": _vm.errors.first(
                            "defaultPaymentDeadline"
                          )
                        }
                      },
                      [
                        _c("q-input", {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate.disable",
                              value: "numeric|min:0",
                              expression: "'numeric|min:0'",
                              modifiers: { disable: true }
                            }
                          ],
                          staticClass: "col",
                          attrs: {
                            name: "defaultPaymentDeadline",
                            type: "number",
                            placeholder: _vm.$t("payment_deadline"),
                            "data-vv-as": _vm.$t("payment_deadline"),
                            suffix: _vm.$tc(
                              "day",
                              _vm.formData.defaultPaymentDeadline
                            )
                          },
                          model: {
                            value: _vm.formData.defaultPaymentDeadline,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.formData,
                                "defaultPaymentDeadline",
                                $$v
                              )
                            },
                            expression: "formData.defaultPaymentDeadline"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              : _vm._e(),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.generateCustomerNumber || _vm.isEditing,
                    expression: "!generateCustomerNumber || isEditing"
                  }
                ],
                staticClass: "row"
              },
              [
                _c(
                  "q-field",
                  {
                    staticClass: "col-12",
                    attrs: {
                      icon: "account_circle",
                      error: _vm.errors.has("customerNumber"),
                      "error-label": _vm.errors.first("customerNumber")
                    }
                  },
                  [
                    _c("q-input", {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate.disable",
                          value: "max:45",
                          expression: "'max:45'",
                          modifiers: { disable: true }
                        }
                      ],
                      staticClass: "col",
                      attrs: {
                        name: "customerNumber",
                        placeholder: _vm.$t("person_customer_number")
                      },
                      model: {
                        value: _vm.formData.customerNumber,
                        callback: function($$v) {
                          _vm.$set(_vm.formData, "customerNumber", $$v)
                        },
                        expression: "formData.customerNumber"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            ),
            !_vm.isEditing
              ? _c(
                  "div",
                  { staticClass: "row" },
                  [
                    _c(
                      "q-field",
                      [
                        _c("q-checkbox", {
                          attrs: {
                            label: _vm.$t("auto_generate_customer_number")
                          },
                          model: {
                            value: _vm.generateCustomerNumber,
                            callback: function($$v) {
                              _vm.generateCustomerNumber = $$v
                            },
                            expression: "generateCustomerNumber"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              : _vm._e()
          ],
          2
        )
      ]),
      _c("div", { staticClass: "row q-mt-md" }, [
        _c(
          "div",
          { staticClass: "col-12" },
          [
            _c("multi-address-input", {
              attrs: {
                "search-hint": _vm.formData.name,
                "hide-label": "",
                "show-icon": "",
                label: ""
              },
              model: {
                value: _vm.formData.addresses,
                callback: function($$v) {
                  _vm.$set(_vm.formData, "addresses", $$v)
                },
                expression: "formData.addresses"
              }
            })
          ],
          1
        )
      ]),
      _c("div", { staticClass: "row q-mt-md" }, [
        _c(
          "div",
          { staticClass: "col-12" },
          [
            _c("multi-bank-details-input", {
              attrs: { "hide-label": "", "show-icon": "", label: "" },
              model: {
                value: _vm.formData.bankDetails,
                callback: function($$v) {
                  _vm.$set(_vm.formData, "bankDetails", $$v)
                },
                expression: "formData.bankDetails"
              }
            })
          ],
          1
        )
      ]),
      _vm.showAllFields
        ? [
            _c("div", { staticClass: "row q-mt-md" }, [
              _c(
                "div",
                { staticClass: "col-12" },
                [
                  _c("multi-email-input", {
                    attrs: { "hide-label": "", "show-icon": "", label: "" },
                    model: {
                      value: _vm.formData.emailAddresses,
                      callback: function($$v) {
                        _vm.$set(_vm.formData, "emailAddresses", $$v)
                      },
                      expression: "formData.emailAddresses"
                    }
                  })
                ],
                1
              )
            ]),
            _c("div", { staticClass: "row q-mt-md" }, [
              _c(
                "div",
                { staticClass: "col-12" },
                [
                  _c("multi-phone-input", {
                    attrs: { "hide-label": "", "show-icon": "", label: "" },
                    model: {
                      value: _vm.formData.phoneNumbers,
                      callback: function($$v) {
                        _vm.$set(_vm.formData, "phoneNumbers", $$v)
                      },
                      expression: "formData.phoneNumbers"
                    }
                  })
                ],
                1
              )
            ]),
            _c(
              "div",
              { staticClass: "row q-mt-md" },
              [
                _c(
                  "q-field",
                  {
                    staticClass: "col-12",
                    attrs: {
                      icon: "public",
                      error: _vm.errors.has("website"),
                      "error-label": _vm.errors.first("website")
                    }
                  },
                  [
                    _c("q-input", {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate.disable",
                          value: "min:3|max:255",
                          expression: "'min:3|max:255'",
                          modifiers: { disable: true }
                        }
                      ],
                      attrs: {
                        name: "website",
                        placeholder: _vm.$t("company_website")
                      },
                      model: {
                        value: _vm.formData.website,
                        callback: function($$v) {
                          _vm.$set(_vm.formData, "website", $$v)
                        },
                        expression: "formData.website"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "row q-mt-md" },
              [
                _c(
                  "q-field",
                  {
                    staticClass: "col-12",
                    attrs: {
                      icon: "account_circle",
                      error: _vm.errors.has("accountsReceivableNumber"),
                      "error-label": _vm.errors.first(
                        "accountsReceivableNumber"
                      )
                    }
                  },
                  [
                    _c("q-input", {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate.disable",
                          value: "max:45",
                          expression: "'max:45'",
                          modifiers: { disable: true }
                        }
                      ],
                      staticClass: "col",
                      attrs: {
                        name: "accountsReceivableNumber",
                        placeholder: _vm.$t("accounts_receivable_number"),
                        clearable: ""
                      },
                      model: {
                        value: _vm.formData.accountsReceivableNumber,
                        callback: function($$v) {
                          _vm.$set(
                            _vm.formData,
                            "accountsReceivableNumber",
                            $$v
                          )
                        },
                        expression: "formData.accountsReceivableNumber"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "row q-mt-md" },
              [
                _c(
                  "q-field",
                  {
                    staticClass: "col-12",
                    attrs: {
                      icon: "account_circle",
                      error: _vm.errors.has("accountsPayableNumber"),
                      "error-label": _vm.errors.first("accountsPayableNumber")
                    }
                  },
                  [
                    _c("q-input", {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate.disable",
                          value: "max:45",
                          expression: "'max:45'",
                          modifiers: { disable: true }
                        }
                      ],
                      staticClass: "col",
                      attrs: {
                        name: "accountsPayableNumber",
                        placeholder: _vm.$t("accounts_payable_number"),
                        clearable: ""
                      },
                      model: {
                        value: _vm.formData.accountsPayableNumber,
                        callback: function($$v) {
                          _vm.$set(_vm.formData, "accountsPayableNumber", $$v)
                        },
                        expression: "formData.accountsPayableNumber"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ]
        : _vm._e(),
      _c(
        "div",
        { staticClass: "q-mt-md" },
        [
          _c(
            "q-btn",
            {
              staticClass: "q-px-none",
              attrs: {
                flat: "",
                icon: _vm.showAllFields ? "expand_less" : "expand_more",
                color: "primary"
              },
              on: {
                click: function($event) {
                  _vm.showAllFields = !_vm.showAllFields
                }
              }
            },
            [
              _vm._v(
                "\n      " +
                  _vm._s(
                    _vm.showAllFields
                      ? _vm.$t("show_less")
                      : _vm.$t("show_more")
                  ) +
                  "\n    "
              )
            ]
          )
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }